<toast-notification #toastNotification></toast-notification>

<div class="acs-toolbar-scroll">
  <!-- Search bar -->
  <div class="acs-toolbar">
    <div class="acs-flex acs-flex--center acs-gap-sm">
      <div class="acs-toolbar__field">
        <i class="fa-solid fa-search acs-toolbar__icon"></i>
        <input type="text" class="acs-input acs-toolbar__input" placeholder="Search by name or email..."
               [(ngModel)]="nameFilter" (keyup.enter)="loadUsers()">
      </div>
      <div class="acs-toolbar__field">
        <i class="fa-solid fa-location-dot acs-toolbar__icon"></i>
        <input type="text" class="acs-input acs-toolbar__input" placeholder="Office location..."
               [(ngModel)]="officeFilter" (keyup.enter)="loadUsers()">
      </div>
      <button class="acs-action-btn" (click)="loadUsers()">
        <i class="fa-solid fa-search"></i>
      </button>
    </div>
    <div class="acs-flex acs-flex--center acs-gap-sm">
      <small *ngIf="users.length > 0" class="acs-text-muted">{{users.length}} user(s)</small>
      <button type="button" class="acs-action-btn acs-action-btn--danger"
              [disabled]="bulkDelete.selectedCount === 0"
              (click)="bulkDelete.requestDelete()">
        <i class="fa-solid fa-trash"></i> Delete<span *ngIf="bulkDelete.selectedCount > 0"> ({{bulkDelete.selectedCount}})</span>
      </button>
      <button type="button" class="acs-action-btn acs-action-btn--accent" (click)="addNewUser()">
        <i class="fa-solid fa-plus"></i> Add User
      </button>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="!hasSearched" class="acs-table-wrap--connected acs-empty-state-wrap">
    <div class="acs-empty-state">
      <i class="fa-solid fa-users"></i>
      Search by name or office to view users
    </div>
  </div>

  <div *ngIf="hasSearched" class="acs-table-wrap acs-table-wrap--connected acs-table--contained">
    <table class="acs-table acs-table--striped acs-table--hover acs-table--bordered">
      <thead class="acs-thead--primary acs-sticky">
        <tr>
          <th class="acs-table__checkbox-col">
            <input type="checkbox" class="acs-table__checkbox"
                   [checked]="bulkDelete.allVisibleSelected && users.length > 0"
                   (change)="bulkDelete.toggleSelectAll()">
          </th>
          <th>Name</th>
          <th>UserID</th>
          <th>Email</th>
          <th>Office</th>
          <th>Phone</th>
          <th class="acs-text-center">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of users" (click)="selectUser(user)" class="acs-cursor-pointer"
            [class.acs-tr--active]="selectedUser?.userId === user.userId"
            [class.acs-bold]="selectedUser?.userId === user.userId">
          <td class="acs-table__checkbox-col" (click)="$event.stopPropagation()">
            <input type="checkbox" class="acs-table__checkbox"
                   [checked]="bulkDelete.isSelected(user.userId)"
                   (change)="bulkDelete.toggle(user.userId, $event)">
          </td>
          <td>{{user.userName}}</td>
          <td>{{getUserId(user.userEmail)}}</td>
          <td>{{user.userEmail}}</td>
          <td>{{user.officeLocation}}</td>
          <td>{{user.phoneNumber}}</td>
          <td class="acs-text-center">
            <span class="acs-badge" [class.acs-badge--success]="isActive(user)" [class.acs-badge--danger]="!isActive(user)">
              {{isActive(user) ? 'Active' : 'Inactive'}}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Detail Modal -->
<div *ngIf="showForm" class="acs-modal" tabindex="-1">
  <div class="acs-modal__dialog acs-modal__dialog--lg">
    <div class="acs-modal__content">
      <div class="acs-modal__header">
        <h6 class="acs-modal__title">{{userForm.get('userName')?.value || 'New User'}}</h6>
        <button type="button" class="acs-btn--close" (click)="cancel()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="acs-modal__body">
        <div class="acs-section-title">User Details</div>
        <form [formGroup]="userForm">
          <div class="acs-row acs-mb-2">
            <div class="acs-col--md6">
              <label class="acs-label">Name</label>
              <input type="text" class="acs-input" formControlName="userName" [readonly]="!isEditing">
            </div>
            <div class="acs-col--md6">
              <label class="acs-label">Email</label>
              <input type="text" class="acs-input" formControlName="userEmail" [readonly]="!isEditing">
            </div>
          </div>
          <div class="acs-row acs-mb-2">
            <div class="acs-col--md6">
              <label class="acs-label">Phone</label>
              <input type="text" class="acs-input" formControlName="phoneNumber">
            </div>
            <div class="acs-col--md6">
              <label class="acs-label">Office</label>
              <input type="text" class="acs-input" formControlName="officeLocation" [readonly]="!isEditing">
            </div>
          </div>
          <div class="acs-row acs-mb-2">
            <div class="acs-col--md6">
              <label class="acs-label">Access Level</label>
              <select class="acs-select" formControlName="accessLevel">
                <option *ngFor="let level of accessLevels" [value]="level.value">{{level.text}}</option>
              </select>
            </div>
            <div class="acs-col--md6">
              <label class="acs-label">Role</label>
              <select class="acs-select" formControlName="userRole"
                      [class.acs-select--invalid]="userForm.get('userRole')?.invalid && userForm.get('userRole')?.touched">
                <option value="">-- Select --</option>
                <option *ngFor="let role of roles" [value]="role.value">{{role.text}}</option>
              </select>
              <div *ngIf="userForm.get('userRole')?.invalid && userForm.get('userRole')?.touched"
                   class="acs-field-error">Role is required</div>
            </div>
          </div>
          <div class="acs-row acs-mb-2">
            <div class="acs-col--md6">
              <label class="acs-label">Default Trade Unit</label>
              <select class="acs-select" formControlName="defaultLocCode">
                <option value="">-- Select --</option>
                <option *ngFor="let loc of defaultLocOptions" [value]="loc.locCode">{{loc.locCode}} - {{loc.description}}</option>
              </select>
            </div>
            <div class="acs-col--md6">
              <label class="acs-label">Deactivate Date</label>
              <div class="acs-input-group">
                <input type="date" class="acs-input" formControlName="inactiveDate">
                <button *ngIf="userForm.get('inactiveDate')?.value" class="acs-btn acs-btn--outline-secondary"
                        type="button" (click)="userForm.patchValue({inactiveDate: null})">
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </div>
            </div>
          </div>
        </form>

        <!-- Assignments (only when editing existing user) -->
        <div *ngIf="isEditing" class="acs-section-divider">
          <div class="acs-section-title">Assignments</div>
          <div class="acs-row">
            <!-- Trade Unit Assignments -->
            <div class="acs-col--md6">
              <div class="acs-flex acs-flex--between acs-flex--center acs-mb-2">
                <h6 class="acs-small acs-bold acs-mb-0">Add Trade Unit</h6>
                <button type="button" class="acs-action-btn acs-action-btn--danger acs-action-btn--sm"
                        [disabled]="selectedAssignedLocCount === 0"
                        (click)="requestRemoveAssignedLocs()">
                  <i class="fa-solid fa-trash"></i> Remove<span *ngIf="selectedAssignedLocCount > 0"> ({{selectedAssignedLocCount}})</span>
                </button>
              </div>
              <div class="acs-pos-rel acs-mb-2">
                <input type="text" class="acs-input"
                       placeholder="Search..."
                       [(ngModel)]="locSearchTerm"
                       [ngModelOptions]="{standalone: true}"
                       (click)="$event.stopPropagation()"
                       (focus)="openLocDropdown()"
                       (input)="showLocDropdown = true">
                <div *ngIf="showLocDropdown && filteredLocs.length > 0"
                     class="acs-pos-abs acs-w-full acs-border acs-bg-white acs-shadow-sm acs-assign-dropdown"
                     (mousedown)="$event.preventDefault()" (click)="$event.stopPropagation()">
                  <div *ngFor="let loc of filteredLocs"
                       class="acs-assign-dropdown__option"
                       [class.acs-assign-dropdown__option--selected]="isPendingLoc(loc.locCode)"
                       (click)="togglePendingLoc(loc)">
                    <span class="acs-check-icon" [class.acs-check-icon--checked]="isPendingLoc(loc.locCode)"></span>
                    {{loc.locCode}} - {{loc.description}}
                  </div>
                  <div *ngIf="pendingLocCount > 0" class="acs-assign-dropdown__footer">
                    <button class="acs-btn acs-btn--primary acs-btn--sm" (click)="addPendingLocs()">
                      Add {{pendingLocCount}} Trade Unit(s)
                    </button>
                  </div>
                </div>
              </div>
              <div class="acs-assign-scroll">
                <table class="acs-table acs-table--blue acs-table--striped acs-table--hover acs-table--bordered acs-mb-0">
                  <thead class="acs-thead--primary acs-sticky">
                    <tr>
                      <th class="acs-table__checkbox-col">
                        <input type="checkbox" class="acs-table__checkbox"
                               [checked]="allAssignedLocsSelected && assignedLocs.length > 0"
                               (change)="toggleSelectAllAssignedLocs()">
                      </th>
                      <th>Trade Unit</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let loc of assignedLocs">
                      <td class="acs-table__checkbox-col">
                        <input type="checkbox" class="acs-table__checkbox"
                               [checked]="isAssignedLocSelected(loc.locCode)"
                               (change)="toggleAssignedLocSelect(loc.locCode)">
                      </td>
                      <td class="acs-small">{{loc.locCode}}</td>
                      <td class="acs-small">{{loc.description}}</td>
                    </tr>
                  </tbody>
                </table>
                <div *ngIf="assignedLocs.length === 0" class="acs-empty-state">
                  <i class="fa-solid fa-building"></i>
                  No trade units assigned
                </div>
              </div>
            </div>

            <!-- Group Assignments -->
            <div class="acs-col--md6">
              <div class="acs-flex acs-flex--between acs-flex--center acs-mb-2">
                <h6 class="acs-small acs-bold acs-mb-0">Add Group Code</h6>
                <button type="button" class="acs-action-btn acs-action-btn--danger acs-action-btn--sm"
                        [disabled]="selectedAssignedGroupCount === 0"
                        (click)="requestRemoveAssignedGroups()">
                  <i class="fa-solid fa-trash"></i> Remove<span *ngIf="selectedAssignedGroupCount > 0"> ({{selectedAssignedGroupCount}})</span>
                </button>
              </div>
              <div class="acs-pos-rel acs-mb-2">
                <input type="text" class="acs-input"
                       placeholder="Search..."
                       [(ngModel)]="groupSearchTerm"
                       [ngModelOptions]="{standalone: true}"
                       (click)="$event.stopPropagation()"
                       (focus)="openGroupDropdown()"
                       (input)="showGroupDropdown = true">
                <div *ngIf="showGroupDropdown && filteredGroups.length > 0"
                     class="acs-pos-abs acs-w-full acs-border acs-bg-white acs-shadow-sm acs-assign-dropdown"
                     (mousedown)="$event.preventDefault()" (click)="$event.stopPropagation()">
                  <div *ngFor="let group of filteredGroups"
                       class="acs-assign-dropdown__option"
                       [class.acs-assign-dropdown__option--selected]="isPendingGroup(group.groupId)"
                       (click)="togglePendingGroup(group)">
                    <span class="acs-check-icon" [class.acs-check-icon--checked]="isPendingGroup(group.groupId)"></span>
                    {{group.groupCode}} - {{group.groupName}}
                  </div>
                  <div *ngIf="pendingGroupCount > 0" class="acs-assign-dropdown__footer">
                    <button class="acs-btn acs-btn--primary acs-btn--sm" (click)="addPendingGroups()">
                      Add {{pendingGroupCount}} Group(s)
                    </button>
                  </div>
                </div>
              </div>
              <div class="acs-assign-scroll">
                <table class="acs-table acs-table--blue acs-table--striped acs-table--hover acs-table--bordered acs-mb-0">
                  <thead class="acs-thead--primary acs-sticky">
                    <tr>
                      <th class="acs-table__checkbox-col">
                        <input type="checkbox" class="acs-table__checkbox"
                               [checked]="allAssignedGroupsSelected && assignedGroups.length > 0"
                               (change)="toggleSelectAllAssignedGroups()">
                      </th>
                      <th>Group Code</th>
                      <th>Group Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let group of assignedGroups">
                      <td class="acs-table__checkbox-col">
                        <input type="checkbox" class="acs-table__checkbox"
                               [checked]="isAssignedGroupSelected(group.groupId)"
                               (change)="toggleAssignedGroupSelect(group.groupId)">
                      </td>
                      <td class="acs-small">{{group.groupCode}}</td>
                      <td class="acs-small">{{group.groupName}}</td>
                    </tr>
                  </tbody>
                </table>
                <div *ngIf="assignedGroups.length === 0" class="acs-empty-state">
                  <i class="fa-solid fa-layer-group"></i>
                  No groups assigned
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="acs-modal__footer">
        <button class="acs-btn acs-btn--secondary" (click)="cancel()">Cancel</button>
        <button class="acs-btn acs-btn--primary" (click)="saveUser()" [disabled]="userForm.invalid">
          {{isEditing ? 'Update' : 'Save'}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Azure AD People Search -->
<div *ngIf="showPeopleSearch" class="acs-modal" tabindex="-1">
  <div class="acs-modal__dialog" [class.acs-modal__dialog--lg]="peopleResults.length > 0">
    <div class="acs-modal__content">
      <div class="acs-modal__header">
        <h6 class="acs-modal__title">Find User in Directory</h6>
        <button type="button" class="acs-btn--close" (click)="showPeopleSearch = false">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="acs-modal__body">
        <div style="display: flex; gap: 0.5rem;">
          <input type="text" class="acs-input" style="flex: 1;" placeholder="Search by name..."
                 [(ngModel)]="peopleSearchTerm" (keyup.enter)="searchAD()">
          <button class="acs-btn acs-btn--primary" (click)="searchAD()">
            <i class="fa-solid fa-magnifying-glass me-1"></i> Search
          </button>
        </div>
        <div *ngIf="peopleSearching" class="acs-text-muted acs-small" style="margin-top: 0.75rem;">Searching...</div>
        <div *ngIf="peopleResults.length > 0" class="acs-table-wrap" style="max-height: 300px; overflow-y: auto; margin-top: 0.75rem;">
          <table class="acs-table acs-table--hover acs-table--bordered">
            <thead class="acs-thead--primary">
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Main Phone</th>
                <th>Mobile</th>
                <th>City</th>
                <th style="width: 70px;"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of peopleResults" [class.acs-text-muted]="isExistingUser(p.email)">
                <td>{{p.displayName}}</td>
                <td class="acs-small">{{p.email}}</td>
                <td class="acs-small">{{p.mainPhone}}</td>
                <td class="acs-small">{{p.mobilePhone}}</td>
                <td>{{p.officeLocation}}</td>
                <td>
                  <span *ngIf="isExistingUser(p.email)" class="acs-badge acs-badge--warning">Already Added</span>
                  <button *ngIf="!isExistingUser(p.email)" class="acs-btn acs-btn--outline-primary" (click)="selectPerson(p)">Select</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="!peopleSearching && peopleSearched && peopleResults.length === 0" class="acs-text-muted acs-small" style="margin-top: 0.75rem;">
          No results. Try a different name.
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Bulk Delete Confirmation Dialog -->
<div *ngIf="bulkDelete.showConfirm" class="acs-modal" tabindex="-1">
  <div class="acs-modal__dialog acs-modal__dialog--sm">
    <div class="acs-modal__content">
      <div class="acs-modal__header">
        <h6 class="acs-modal__title">Confirm Delete</h6>
        <button type="button" class="acs-btn--close" (click)="bulkDelete.cancelDelete()" [disabled]="bulkDelete.isDeleting">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="acs-modal__body">
        <p>Delete <strong>{{bulkDelete.selectedCount}}</strong> user(s)? This action cannot be undone.</p>
      </div>
      <div class="acs-modal__footer">
        <button class="acs-btn acs-btn--secondary" (click)="bulkDelete.cancelDelete()" [disabled]="bulkDelete.isDeleting">Cancel</button>
        <button class="acs-btn acs-btn--danger" (click)="confirmBulkDelete()" [disabled]="bulkDelete.isDeleting">
          {{bulkDelete.isDeleting ? 'Deleting...' : 'Yes, Delete'}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Remove Trade Unit Assignments Confirmation -->
<div *ngIf="showRemoveLocConfirm" class="acs-modal" tabindex="-1">
  <div class="acs-modal__dialog acs-modal__dialog--sm">
    <div class="acs-modal__content">
      <div class="acs-modal__header">
        <h6 class="acs-modal__title">Confirm Remove</h6>
        <button type="button" class="acs-btn--close" (click)="cancelRemoveAssignedLocs()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="acs-modal__body">
        <p>Remove <strong>{{selectedAssignedLocCount}}</strong> trade unit assignment(s)?</p>
      </div>
      <div class="acs-modal__footer">
        <button class="acs-btn acs-btn--secondary" (click)="cancelRemoveAssignedLocs()">Cancel</button>
        <button class="acs-btn acs-btn--danger" (click)="confirmRemoveAssignedLocs()">Yes, Remove</button>
      </div>
    </div>
  </div>
</div>

<!-- Remove Group Assignments Confirmation -->
<div *ngIf="showRemoveGroupConfirm" class="acs-modal" tabindex="-1">
  <div class="acs-modal__dialog acs-modal__dialog--sm">
    <div class="acs-modal__content">
      <div class="acs-modal__header">
        <h6 class="acs-modal__title">Confirm Remove</h6>
        <button type="button" class="acs-btn--close" (click)="cancelRemoveAssignedGroups()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="acs-modal__body">
        <p>Remove <strong>{{selectedAssignedGroupCount}}</strong> group assignment(s)?</p>
      </div>
      <div class="acs-modal__footer">
        <button class="acs-btn acs-btn--secondary" (click)="cancelRemoveAssignedGroups()">Cancel</button>
        <button class="acs-btn acs-btn--danger" (click)="confirmRemoveAssignedGroups()">Yes, Remove</button>
      </div>
    </div>
  </div>
</div>
